import type {
  AfriexTransactionChannel,
  PaymentMethodNameResolutionCacheState,
  PaymentMethodNameResolutionStatus,
} from '@afriex/core/domain/enums';

/** One cached name lookup, as GET /v2/admin/processors/name-resolutions returns it. */
export type NameResolution = {
  id: string;
  channel: AfriexTransactionChannel;
  country: string;
  /** Bank code, or the mobile-money provider the lookup asked for. */
  institutionCode: string;
  /** Account number, or the E.164 phone number. */
  accountIdentifier: string;
  info: {accountName?: string; bankName?: string; provider?: string};
  resolvedBy: string;
  processor?: string;
  status: PaymentMethodNameResolutionStatus;
  cacheState: PaymentMethodNameResolutionCacheState;
  resolveCount: number;
  lastResolvedAt: string;
  createdAt?: string;
};

// The shared Select renders its placeholder as a disabled `value=""` option,
// so "any" cannot be the empty string.
export const ANY = '__any__';

export type NameResolutionFilterState = {
  channel: AfriexTransactionChannel | typeof ANY;
  country: string;
  resolvedBy: string;
  status: PaymentMethodNameResolutionStatus | typeof ANY;
  search: string;
};

export const PAGE_SIZE = 20;
